import React from "react";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    box-sizing: border-box;
    padding: 0 clamp(1rem, 3vw, 3.5rem) 2rem;
    flex-grow: 1;
    background: var(--calendar-bg, #f5f7fb);
    color: var(--calendar-text, #171A22);

    @media (max-width: 640px) {
        padding: 0 1rem 1.5rem;
    }
`;

/**
 * A container to display content to the right of the nav bar while logged in
 * @return {JSX.Element}
 */
export function PageContainer(props) {
    const { children, ...styleProps } = props;
    return (
        <Container {...styleProps}>
            {children}
        </Container>
    );
}
